import { Component, ComponentFactoryResolver } from "@angular/core";
import { SmallCardComponent } from "@app/home/cards/small-card/small-card.component";
import { SvgRxRenewalComponent } from "@app/home/svg/svg-rx-renewal/svg-rx-renewal.component";
import { ConfigService } from "@app/core/config.service";
import { HomePageAnalyticsService } from "@app/home/home-page-analytics.service";

@Component({
  selector: "om-rx-renewal-card",
  templateUrl: "./small-card/small-card.component.html",
  styleUrls: ["./default-styling.scss", "./small-card/small-card.component.scss"],
})
export class RxRenewalCardComponent extends SmallCardComponent {
  constructor(
    private config: ConfigService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private homePageAnalyticsService: HomePageAnalyticsService
  ) {
    super();
  }

  ngOnInit() {
    this.card = {
      svg: this.componentFactoryResolver.resolveComponentFactory(SvgRxRenewalComponent),
      title: "Request Prescription\nRenewal",
      link: `${this.config.json.myoneServer}/pt/prescription_web_renewal`,
    };

    this.homePageAnalyticsService.trackRequestPrescriptionRenewalLink("om-rx-renewal-card a");

    super.ngOnInit();
  }
}
